const data = {
  youtube: "",
  telegram: "https://t.me/hydraflasher",
  telegramchnl: "https://t.me/hydraflasher_com",
  twitter: "https://twitter.com/HydraFlasher"
}

export default data